import type { ApolloClient } from '@apollo/client';
import { useState } from 'react';
import { RouterProvider } from 'react-router';
import { Providers } from './providers';
import { createRouter } from './router';

export function App({ client }: { client: ApolloClient }) {
  const [router] = useState(createRouter);
  return (
    <Providers client={client}>
      <RouterProvider router={router} />
    </Providers>
  );
}
